// extracted by mini-css-extract-plugin
module.exports = {"videoFooter":"VideoPlayerComp_videoFooter__3XPCI","videoTitle":"VideoPlayerComp_videoTitle__3QjSc","liveLabel":"VideoPlayerComp_liveLabel__3TzbM"};